import { render, staticRenderFns } from "./DisposalInfo.vue?vue&type=template&id=41b49568&scoped=true"
import script from "./DisposalInfo.vue?vue&type=script&lang=js"
export * from "./DisposalInfo.vue?vue&type=script&lang=js"
import style0 from "./DisposalInfo.vue?vue&type=style&index=0&id=41b49568&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b49568",
  null
  
)

export default component.exports